export default "__VITE_ASSET__CJiz_4c$__"